module.exports = __webpack_public_path__ + "img/header-proxpect.2a822816.jpeg";